import { IconTelegram } from '../components/icons';
import { openExternal } from '../lib/tg';

export function Paywall({ botUsername, salesOpen, firstName, paying = false, onPay }: { botUsername: string | null; salesOpen: boolean; firstName?: string | null; paying?: boolean; onPay?: () => void }) {
  const bot = botUsername ? `https://t.me/${botUsername}?start=pay` : null;
  const name = firstName ? `${firstName}, ` : '';
  return (
    <main className="state page">
      <p className="overline">FaceControl · клуб Яны Чикало</p>
      <h1 className="state__title h-display">Клуб закрыт для вас на этот месяц</h1>
      <p className="state__text">
        {salesOpen
          ? `${name}продажи открыты: оформите подписку, и уроки этого месяца появятся здесь сразу после оплаты.`
          : `${name}оформить подписку можно с 1 по 5 число каждого месяца. Мы напомним в боте, когда откроются продажи.`}
      </p>
      <div className="state__actions">
        {salesOpen && onPay ? (
          <button type="button" className="btn" disabled={paying} onClick={onPay}>
            {paying ? 'Открываем оплату…' : 'Оформить подписку · 2000 ₽'}
          </button>
        ) : bot ? (
          <button type="button" className="btn" onClick={() => openExternal(bot)}>
            <IconTelegram /> {salesOpen ? 'Оформить подписку' : 'Открыть бота'}
          </button>
        ) : (
          <p className="state__text">Откройте бота клуба, чтобы оформить подписку.</p>
        )}
      </div>
    </main>
  );
}

export function NotTelegram({ botUsername }: { botUsername: string | null }) {
  return (
    <main className="state page">
      <h1 className="state__title h-display">Это приложение живёт внутри Telegram</h1>
      <p className="state__text">Откройте бота клуба FaceControl и нажмите «Открыть приложение» — уроки, гайды и эфиры будут там.</p>
      {botUsername && (
        <div className="state__actions">
          <a className="btn" href={`https://t.me/${botUsername}`}>
            <IconTelegram /> Открыть в Telegram
          </a>
        </div>
      )}
    </main>
  );
}

export function ErrorScreen({ title, text, onRetry, dark = false }: { title: string; text: string; onRetry?: () => void; dark?: boolean }) {
  return (
    <main className={`state page${dark ? ' state--quiet' : ''}`}>
      <h1 className="state__title h-display">{title}</h1>
      <p className="state__text">{text}</p>
      {onRetry && (
        <div className="state__actions">
          <button type="button" className="btn btn--ghost" onClick={onRetry}>
            Попробовать ещё раз
          </button>
        </div>
      )}
    </main>
  );
}
